module.exports = __webpack_public_path__ + "static/media/zheka.958557d6.png";